import { scopedConversationStats, coalesceConversationStats } from '../../attention/conversationStatsScope';
import { attentionEnabled } from '../../attention/state';
import types from '../mutation-types';
import ConversationApi from '../../api/inbox/conversation';
import { debounce } from '@chatwoot/utils';

const state = {
  mineCount: 0,
  unAssignedCount: 0,
  allCount: 0,
};

const originalGetters = {
  getStats: $state => $state,
};

// Create a debounced version of the actual API call function
const fetchMetaData = async (commit, params, current, beginDispatch, requestOptions = {}) => {
  if (!current?.()) return;
  const currentResponse = beginDispatch();
  if (!currentResponse()) return;
  try {
    const response = await ConversationApi.meta(params, requestOptions);
    const {
      data: { meta },
    } = response;
    if (currentResponse()) commit(types.SET_CONV_TAB_META, meta);
  } catch (error) {
    // ignore
  }
};

const attentionFetchMetaData = coalesceConversationStats(fetchMetaData);

const debouncedFetchMetaData = debounce(fetchMetaData, 500, false, 2000);
const longDebouncedFetchMetaData = debounce(fetchMetaData, 5000, false, 10000);
const superLongDebouncedFetchMetaData = debounce(
  fetchMetaData,
  10000,
  false,
  20000
);

const originalActions = {
  get: async ({ commit, state: $state, statsRequestCurrent, statsRequestDispatch }, params) => {
    if (attentionEnabled()) {
      attentionFetchMetaData(commit, params, statsRequestCurrent, statsRequestDispatch, { timeout: 2500 });
    } else if ($state.allCount > 2000) {
      superLongDebouncedFetchMetaData(commit, params, statsRequestCurrent, statsRequestDispatch);
    } else if ($state.allCount > 100) {
      longDebouncedFetchMetaData(commit, params, statsRequestCurrent, statsRequestDispatch);
    } else {
      debouncedFetchMetaData(commit, params, statsRequestCurrent, statsRequestDispatch);
    }
  },
  set({ commit }, meta) {
    commit(types.SET_CONV_TAB_META, meta);
  },
};

export const mutations = {
  [types.SET_CONV_TAB_META](
    $state,
    {
      mine_count: mineCount,
      unassigned_count: unAssignedCount,
      all_count: allCount,
    } = {}
  ) {
    $state.mineCount = mineCount;
    $state.allCount = allCount;
    $state.unAssignedCount = unAssignedCount;
    $state.updatedOn = new Date();
    $state.attentionScopeRevision = ($state.attentionScopeRevision || 0) + 1;
  },
};

const scoped = scopedConversationStats(originalActions, originalGetters);
export const actions = scoped.actions;
export const getters = scoped.getters;

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
